// This component is generated by svgr. DO NOT EDIT.
import { SVGProps } from 'react'
type Props = {
  size?: 'sm' | 'md' | 'lg' | (string & {}),
} & Omit<SVGProps<SVGSVGElement>, 'width' | 'height'>
const SvgScreenShareOn = ({ size = 'md', ...props }: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={
      size === 'sm'
        ? '8px'
        : size === 'md'
        ? '16px'
        : size === 'lg'
        ? '24px'
        : size
    }
    height={
      size === 'sm'
        ? '8px'
        : size === 'md'
        ? '16px'
        : size === 'lg'
        ? '24px'
        : size
    }
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <g
      fill={props.color ?? 'currentColor'}
      clipPath="url(#screen_share_on_svg__a)"
    >
      <path d="M15 15H1c-.55 0-1-.45-1-1V2c0-.55.45-1 1-1h14c.55 0 1 .45 1 1v12c0 .55-.45 1-1 1M2 13h12V3H2z" />
      <path d="m11.21 6.79-2.5-2.5s-.02 0-.03-.02c-.09-.08-.19-.15-.3-.2A1 1 0 0 0 8 3.99h-.03c-.12 0-.24.02-.35.07-.12.05-.24.13-.33.22l-2.5 2.5A.996.996 0 1 0 6.2 8.19l.79-.79v3.58c0 .55.45 1 1 1s1-.45 1-1V7.39l.79.79c.2.2.45.29.71.29s.51-.1.71-.29a.996.996 0 0 0 0-1.41z" />
    </g>
    <defs>
      <clipPath id="screen_share_on_svg__a">
        <path fill="#fff" d="M0 0h16v16H0z" />
      </clipPath>
    </defs>
  </svg>
)
export default SvgScreenShareOn
